import { render, staticRenderFns } from "./nav-link.vue?vue&type=template&id=3328ebcc"
import script from "./nav-link.vue?vue&type=script&lang=js"
export * from "./nav-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports